import {CommonModule, registerLocaleData} from '@angular/common';
import localCo from '@angular/common/locales/es-CO';
// Angular
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {GestureConfig} from '@angular/material/core';
import {OverlayModule} from '@angular/cdk/overlay';
// Perfect Scroll bar
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
// SVG inline
import {InlineSVGModule} from 'ng-inline-svg';
// Hammer JS
import 'hammerjs';
// NGX Permissions
import {NgxPermissionsModule} from 'ngx-permissions';
// NGRX
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
// State
import {metaReducers, reducers} from './core/reducers';
// Components
import {AppComponent} from './app.component';
// Modules
import {AppRoutingModule} from './app-routing.module';
import {CoreModule} from './core/core.module';
import {ThemeModule} from './views/theme/theme.module';
// Partials
import {PartialsModule} from './views/partials/partials.module';
// Components
import {ComponentsModule} from './views/components/components.module'
// Layout Services
import {
  DataTableService,
  KtDialogService,
  LayoutConfigService,
  LayoutRefService,
  MenuAsideService,
  MenuConfigService,
  MenuHorizontalService,
  PageConfigService,
  SplashScreenService,
  SubheaderService
} from './core/_base/layout';
// Auth
import {AuthModule} from './views/pages/auth/auth.module';
// CRUD
import {HttpUtilsService, LayoutUtilsService, TypesUtilsService} from './core/_base/crud';
// Config
import {LayoutConfig} from './core/_config/layout.config';
// Highlight JS
import {HIGHLIGHT_OPTIONS, HighlightModule} from 'ngx-highlightjs';
import xml from 'highlight.js/lib/languages/xml';
import json from 'highlight.js/lib/languages/json';
import scss from 'highlight.js/lib/languages/scss';
import typescript from 'highlight.js/lib/languages/typescript';
//Import modals
import {CrearOperacionModal} from './views/modules/parameters/operaciones/modals/create-modal.component';
import {EditarOperacionModal} from './views/modules/parameters/operaciones/modals/edit-modal.component';
import {ConfirmDeleteComponent} from './views/modules/parameters/paises/modals/confirm-delete/confirm-delete.component';
import {CrearMedioModal} from './views/modules/parameters/medios/modals/create-modal.component';
import {EditarMedioModal} from './views/modules/parameters/medios/modals/edit-modal.component';
import {CrearAmparoModal} from './views/modules/parameters/amparos/modals/create-modal.component';
import {EditarAmparoModal} from './views/modules/parameters/amparos/modals/edit-modal.component';
import {CrearCondicionModal} from './views/modules/parameters/condiciones/modals/create-modal.component';
import {EditarCondicionModal} from './views/modules/parameters/condiciones/modals/edit-modal.component';
import {CrearPesoModal} from './views/modules/parameters/pesos/modals/create-modal.component';
import {EditarPesoModal} from './views/modules/parameters/pesos/modals/edit-modal.component';
import {CrearLinkModal} from './views/modules/parameters/links/modals/create-modal.component';
import {EditarLinkModal} from './views/modules/parameters/links/modals/edit-modal.component';
import {CrearIncotermModal} from './views/modules/parameters/incoterms/modals/create-modal.component';
import {EditarIncotermModal} from './views/modules/parameters/incoterms/modals/edit-modal.component';
import {CrearMonedaModal} from './views/modules/parameters/monedas/modals/create-modal.component';
import {EditarMonedaModal} from './views/modules/parameters/monedas/modals/edit-modal.component';
import {ConversionModal} from './views/modules/parameters/monedas/modals/conversion.component';
import {CrearCiudadModal} from './views/modules/parameters/ciudades/modals/create-modal.component';
import {EditarCiudadModal} from './views/modules/parameters/ciudades/modals/edit-modal.component';
import {CrearPaisModal} from './views/modules/parameters/paises/modals/create-modal.component';
import {EditarPaisModal} from './views/modules/parameters/paises/modals/edit-modal.component';
import {CrearGeneradorModal} from './views/modules/generadores/modals/create-modal.component';
import {EditarGeneradorModal} from './views/modules/generadores/modals/edit-modal.component';
import {ViewUsersModal} from './views/modules/aseguradora/modals/view-users-modal.component';
import {EditUserModal} from './views/modules/aseguradora/modals/edit-user-modal.component';
import {EditImageModal} from './views/modules/aseguradora/modals/edit-image-modal.component';
import {ViewUsersBrokerModal} from './views/modules/intermediario/modals/view-users-modal.component';
import {EditUserBrokerModal} from './views/modules/intermediario/modals/edit-user-modal.component';
import {ViewUsersFinalUserModal} from './views/modules/usuario-final/modals/view-users-modal.component';
import {EditUserFinalUserModal} from './views/modules/usuario-final/modals/edit-user-modal.component';
import {DetailModal} from './views/components/policy-detail/detail-modal/detail-modal.component';
import {ListaModalCrear} from './views/modules/poliza-madre/list-modal/lista-modal-crear.component';
import {ListaModalEditar} from './views/modules/poliza-madre/list-modal/lista-modal-editar.component';
// Chart
import {ChartsModule} from 'ng2-charts';
import {listTermsComponent} from "./views/pages/auth/terms-dialog/list-terms.component";
import {
  ConfirmDeleteParameterComponent
} from "./views/modules/parameters/operaciones/modals/confirm-delete/confirm-delete-parameter.component";
import {
  ConfirmDeleteOperationComponent
} from "./views/modules/parameters/medios/modals/confirm-delete/confirm-delete-operation.component";
import {
  ConfirmDeleteProtectionComponent
} from "./views/modules/parameters/amparos/modals/confirm-delete/confirm-delete-protection.component";
import {
  ConfirmDeleteConditionComponent
} from "./views/modules/parameters/condiciones/modals/confirm-delete/confirm-delete-condition.component";
import {
  ConfirmDeleteCurrencyComponent
} from "./views/modules/parameters/monedas/modals/confirm-delete/confirm-delete-currency.component";
import {
  ConfirmDeleteIcotermsComponent
} from "./views/modules/parameters/incoterms/modals/confirm-delete/confirm-delete-icoterms.component";
import {
  ConfirmDeleteWeightComponent
} from "./views/modules/parameters/pesos/modals/confirm-delete/confirm-delete-weight.component";
import {
  ConfirmDeleteCityComponent
} from "./views/modules/parameters/ciudades/modals/confirm-delete/confirm-delete-city.component";
// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelSpeed: 0.5,
  swipeEasing: true,
  minScrollbarLength: 40,
  maxScrollbarLength: 300
};

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
  // initialize app by loading default demo layout config
  return () => {
    if (appConfig.getConfig() === null) {
      appConfig.loadConfigs(new LayoutConfig().configs);
    }
  };
}

/**
 * Import specific languages to avoid importing everything
 * The following will lazy load highlight.js core script (~9.6KB) + the selected languages bundle (each lang. ~1kb)
 */
export function getHighlightLanguages() {
  return [
    {name: 'typescript', func: typescript},
    {name: 'scss', func: scss},
    {name: 'xml', func: xml},
    {name: 'json', func: json}
  ];
}

registerLocaleData(localCo, 'es-CO');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    HighlightModule,
    PartialsModule,
    CoreModule,
    OverlayModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
    StoreDevtoolsModule.instrument(),
    AuthModule.forRoot(),
    TranslateModule.forRoot(),
    MatProgressSpinnerModule,
    InlineSVGModule.forRoot(),
    ThemeModule,
    ChartsModule,
    ComponentsModule
  ],
  exports: [],
  providers: [
    LayoutConfigService,
    LayoutRefService,
    MenuConfigService,
    PageConfigService,
    KtDialogService,
    DataTableService,
    SplashScreenService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: GestureConfig
    },
    {
      // layout config initializer
      provide: APP_INITIALIZER,
      useFactory: initializeLayoutConfig,
      deps: [LayoutConfigService],
      multi: true
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        languages: getHighlightLanguages
      }
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-CO'
    },
    // template services
    SubheaderService,
    MenuHorizontalService,
    MenuAsideService,
    HttpUtilsService,
    TypesUtilsService,
    LayoutUtilsService
  ],
  bootstrap: [AppComponent],
  entryComponents: [CrearOperacionModal,
    EditarOperacionModal,
    CrearMedioModal,
    EditarMedioModal,
    CrearAmparoModal,
    EditarAmparoModal,
    CrearCondicionModal,
    EditarCondicionModal,
    CrearPesoModal,
    EditarPesoModal,
    CrearLinkModal,
    EditarLinkModal,
    CrearIncotermModal,
    EditarIncotermModal,
    CrearMonedaModal,
    EditarMonedaModal,
    ConversionModal,
    CrearGeneradorModal,
    EditarGeneradorModal,
    ViewUsersModal,
    EditUserModal,
    ViewUsersBrokerModal,
    EditUserBrokerModal,
    ViewUsersFinalUserModal,
    EditUserFinalUserModal,
    CrearCiudadModal,
    EditarCiudadModal,
    CrearPaisModal,
    EditarPaisModal,
    DetailModal,
    EditImageModal,
    ListaModalCrear,
    ListaModalEditar,
    listTermsComponent,
    ConfirmDeleteComponent,
    ConfirmDeleteParameterComponent,
    ConfirmDeleteOperationComponent,
    ConfirmDeleteProtectionComponent,
    ConfirmDeleteConditionComponent,
    ConfirmDeleteCurrencyComponent,
    ConfirmDeleteIcotermsComponent,
    ConfirmDeleteWeightComponent,
    ConfirmDeleteCityComponent
  ]
})
export class AppModule {
}
